import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { FaBusinessTime, FaCheck, FaRoad } from 'react-icons/fa';
import { formatNumber } from 'helpers/utils';
import { AgGridTable } from 'components/common';

const formatDate = (date) => (date ? format(new Date(date), 'MMM, dd-yyyy h:mm aa') : '');

const CheckCell = ({ value }) => (
  <div className="tw-text-center">
    {value ? <FaCheck className="tw-text-green-600" /> : <span className="tw-text-slate-300">—</span>}
  </div>
);
CheckCell.propTypes = { value: PropTypes.bool };

const TransactionDetailDriverTrans = ({ transaction }) => {
  const data = transaction?.driver_trans || [];

  const columnDefs = useMemo(() => [
    {
      headerName: 'ID#',
      field: 'id',
      minWidth: 90,
      cellRenderer: (p) => (
        <Link to={`/booking/car/${transaction.id}/driver-trans/${p.value}/update`} target="_blank">{p.value}</Link>
      ),
    },
    { headerName: 'Driver name', field: 'driver.name', minWidth: 160 },
    { headerName: 'Car name', field: 'car.name', minWidth: 140 },
    { headerName: 'Confirmed', field: 'confirmed', minWidth: 110, cellRenderer: CheckCell },
    { headerName: 'Confirmed date', field: 'confirmed_date', minWidth: 160 },
    { headerName: 'Confirmed by', field: 'confirmed_by', minWidth: 150 },
    { headerName: 'Departure begin time', field: 'departure_begin_time', minWidth: 190, valueFormatter: (p) => formatDate(p.value) },
    { headerName: 'Departure end time', field: 'departure_end_time', minWidth: 190, valueFormatter: (p) => formatDate(p.value) },
    { headerName: 'Total hours', field: 'total_hours', minWidth: 120 },
    { headerName: 'Departure from (Km)', field: 'departure_begin_kilometer', minWidth: 160 },
    { headerName: 'Departure end (Km)', field: 'departure_end_kilometer', minWidth: 160 },
    { headerName: 'Total (Km)', field: 'total_kilometers', minWidth: 120 },
    { headerName: 'Parking fee', field: 'parking_fee', minWidth: 130, valueFormatter: (p) => formatNumber(p.value, 'VND') },
    { headerName: 'Notes', field: 'notes', minWidth: 180 },
    { headerName: 'Closed', field: 'closed', minWidth: 90, cellRenderer: CheckCell },
    {
      headerName: 'Attachments',
      field: 'images',
      minWidth: 180,
      cellRenderer: (p) => (
        <ul className="tw-list-none tw-p-0 tw-m-0">
          {(p.value || []).map((image) => (
            <li key={image.id}><Link to={image.url} target="_blank">{image.name}</Link></li>
          ))}
        </ul>
      ),
    },
    { headerName: 'Assigned by', field: 'created_by', minWidth: 150 },
    { headerName: 'Assigned date', field: 'created_at', minWidth: 160 },
  ], [transaction.id]);

  return (
    <div>
      <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-3 tw-mb-3">
        <div className="tw-flex tw-items-center tw-gap-2 tw-bg-blue-600 tw-text-white tw-rounded tw-px-4 tw-py-3">
          <FaBusinessTime size={20} />
          <span>Total times: <span className="tw-text-lg tw-font-bold">{transaction.total_hours_booking} hours</span></span>
        </div>
        <div className="tw-flex tw-items-center tw-gap-2 tw-bg-blue-600 tw-text-white tw-rounded tw-px-4 tw-py-3">
          <FaRoad size={20} />
          <span>Total kilometers: <span className="tw-text-lg tw-font-bold">{transaction.total_hours_booking} km</span></span>
        </div>
      </div>

      <div className="tw-bg-white tw-rounded tw-border tw-border-solid tw-border-slate-200 tw-overflow-hidden">
        <AgGridTable rowData={data} columnDefs={columnDefs} pagination height="40vh" />
      </div>
    </div>
  );
};

TransactionDetailDriverTrans.propTypes = {
  transaction: PropTypes.object.isRequired,
};

export default TransactionDetailDriverTrans;
